import script from "./ListPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPagination.vue?vue&type=script&setup=true&lang=js"

import "./ListPagination.vue?vue&type=style&index=0&id=354fa4ca&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-354fa4ca"]])

export default __exports__